import { render, staticRenderFns } from "./search-groups.vue?vue&type=template&id=66d6cd2e&"
import script from "./search-groups.vue?vue&type=script&lang=js&"
export * from "./search-groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports